import React, { useEffect } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider, useQueryClient } from "@tanstack/react-query";

import App from "@/App";
import "@/index.css";
import "@/lib/i18n"; // side-effect: initialise i18next before any component renders
import { AuthProvider } from "@/lib/AuthContext";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5_000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

// When the operator switches language, content names come from the backend
// under the new X-Locale header — so every cached query is stale.  Invalidate
// the whole cache so localised content re-fetches.  UI strings are handled
// reactively by react-i18next and don't need this.
function LocaleSync() {
  const qc = useQueryClient();
  useEffect(() => {
    const onChange = () => void qc.invalidateQueries();
    window.addEventListener("mes:locale-change", onChange);
    return () => window.removeEventListener("mes:locale-change", onChange);
  }, [qc]);
  return null;
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <QueryClientProvider client={queryClient}>
          <LocaleSync />
          <App />
        </QueryClientProvider>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>,
);
